__turbopack_context__.v({
  "root": "Map-module__sq_0iW__root",
});
